import styled from 'styled-components';

export const Wrapper = styled.div<{ bordered?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: start;
  align-items: start;
  flex: 2;
  gap: 16px;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  padding: 40px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;

export const EmojiWrapper = styled.div`
  display: flex;
  width: 40px;
  height: 40px;
  padding: 0 5px;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px;
  letter-spacing: -0.5px;
`;

export const Text = styled.span`
  align-self: stretch;
  color: ${({ theme }) => theme.colors.black7};
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;
`;
export const Description = styled.span`
  align-self: stretch;
  color: ${({ theme }) => theme.colors.black7};
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;
export const SkeletonImageWrapper = styled.img`
  max-width: 100%;
  height: auto;
  object-fit: contain;
`;
